import { render, staticRenderFns } from "./DbPage.vue?vue&type=template&id=30b19156&scoped=true&"
import script from "./DbPage.vue?vue&type=script&lang=ts&"
export * from "./DbPage.vue?vue&type=script&lang=ts&"
import style0 from "./DbPage.vue?vue&type=style&index=0&id=30b19156&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b19156",
  null
  
)

export default component.exports